import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { ContentService } from 'src/app/shared/services/content.service';
import { SweetAlert } from "sweetalert/typings/core";
const swal: SweetAlert = require("sweetalert");
@Component({
  selector: 'app-job-portal',
  templateUrl: './job-portal.component.html',
  styleUrls: ['./job-portal.component.scss']
})
export class JobPortalComponent implements OnInit {

  @Output() backToCareerPage: any = new EventEmitter()
  openFormStatus: any = 'false';
  instructionList: any = []

  constructor(private contentService: ContentService) { }

  ngOnInit(): void {
    this.openFormStatus = sessionStorage.getItem('openFormStatus') ? sessionStorage.getItem('openFormStatus') : 'false';
    let jobPortalDetails = JSON.parse(sessionStorage.getItem('particularPositionDetails') !);
    if(jobPortalDetails?.instructions === 'undefined') {
       jobPortalDetails.instructions = 'No Instructions'
    }
    this.instructionList = jobPortalDetails && jobPortalDetails?.instructions ? jobPortalDetails?.instructions : `<ol><li><p><span><font color="#3165d0">Government Exam Instructions</font></span></p><p><span><font color="#8ed8fc" size="3" face="Times New Roman">Before the Exam:</font></span></p><ol><li><p><span>Required Documents</span>: Ensure you have all the necessary documents such as your admit card, photo identification (e.g., passport, driver's license), and any other documents specified in the exam notification.</p></li><li><p><span>Stationery</span>: Bring essential stationery item like pens (black or blue ink), pencils, erasers, and a photo ID. Make sure they are in good working condition.</p></li><li><p><span>Electronic Devices</span>: Leave all electronic devices (mobile phones, tablets, smartwatches, etc.) outside the examination hall as they are usually not allowed.</p></li></ol><p><span><font size="3" color="#0080ff">During the Exam:</font></span></p><ol><li><p><span>Seating Arrangement</span>: Follow the instructions of the exam invigilator and find your designated seat. Do not change your seat without permission.</p></li><li><p><span>Admit Card</span>: Place your admit card and ID on your desk. Keep them readily accessible for inspection.</p></li><li><p><span>Instructions</span>: Listen carefully to the exam invigilator's instructions and read the instructions on the question paper.</p></li><li><p><span>Time Management</span>: Manage your time wisely. Allocate a specific amount of time to each section or question, as applicable.</p></li><li><p><span>Question Paper</span>: Check if the question paper is complete and if there are any missing or misprinted pages. Inform the invigilator if you find any issues.</p></li><li><p><span>Answer Sheet</span>: Fill in your personal details on the answer sheet (if required) and question paper as instructed.</p></li><li><p><span>Marking</span>: Use a pen with black or blue ink to mark your answers on the answer sheet. Follow the specified method for marking (e.g., filling circles, shading boxes).</p></li><li><p><span>Noise and Disturbances</span>: Maintain a silent and focused environment within the examination hall. Do not engage in any form of cheating, talking, or disruptive behavior.</p></li><li><p><span>Restroom Breaks</span>: If restroom breaks are allowed, raise your hand and wait for the invigilator's permission. Follow their directions.</p></li></ol><p><span>After the Exam:</span></p><ol><li><p><span>Submission</span>: Submit your answer sheet and question paper to the invigilator or as instructed.</p></li><li><p><span>Exit</span>: Leave the examination hall quietly, ensuring you do not disturb other candidates.</p></li><li><p><span>Collect Belongings</span>: Collect any belongings you left outside the examination hall, such as electronic devices or bags.</p></li><li><p><span>Results</span>: Wait for the official results announcement through the designated channels mentioned in the exam notification.</p></li><li><p><span>Feedback</span>: If there were any irregularities or concerns during the exam, report them to the relevant authorities in accordance with the exam guidelines.</p></li></ol><p>Remember to carefully read the specific instructions provided by the examination authorities for your particular exam, as requirements may vary. Good luck with your government exam!</p></li></ol>`
    // this.getInstructionsData()
  }

  getInstructionsData() {
    this.contentService.getInstructionData().subscribe((res:any) => {
      // console.log("Instruction Response ", res)
      if(res?.responseCode == '200') {
         this.getTheFormattedInstructionData(res?.wrapperList[0].title.split('\n'))
      }
    },(err) => {
      if(err.status !== 403) {
        swal("", `${err?.error?.errorMsg ? err?.error?.errorMsg : 'Internal server error'}`, "error");
      }
      // swal("", `${err?.error?.errorMsg ? err?.error?.errorMsg : 'Internal server error'}`, "error");
    })
  }

  getTheFormattedInstructionData(title:any) {
    // console.log("Instrction title ", title)
    this.instructionList = title
  }

  backButton() {
    this.backToCareerPage.emit('false')
  }

  openForm() {
    this.openFormStatus = 'true'
    sessionStorage.setItem('openFormStatus', this.openFormStatus)
    this.removeDataFromSessionStorage(['educationQualification', 'languageData', 'experienceData', 'refrenceData'])
  }

  jobPortalFormSuccessfully(event:any) {
    if(event === 'false') {
      this.openFormStatus = 'false';
      this.removeDataFromSessionStorage(['openFormStatus', 'educationQualification', 'languageData', 'experienceData', 'refrenceData'])
      this.backButton()
    }
  }

  comingToInstructionPage(event:any) {
    this.openFormStatus = 'false';
    this.removeDataFromSessionStorage(['openFormStatus', 'educationQualification', 'languageData', 'experienceData', 'refrenceData'])
    this.backButton()
  }

  removeDataFromSessionStorage(data:any) {
    data.forEach((item:any) => {
      sessionStorage.removeItem(item)
    })
  } 

}
